import { init as client } from 'services/user'
import { generateRoute } from 'config/routes'

export const LogoutPage = props => {
	client().clearAuthentication()

	props.history.push(generateRoute('login'))
}
